import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const VisualBreak = ({ image, imageAlt, stat }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[60vh] min-h-[420px] overflow-hidden" data-testid="visual-break-section">
      <motion.div style={{ y }} className="absolute inset-0 scale-[1.25]">
        <img src={image} alt={imageAlt} className="h-full w-full object-cover" loading="lazy" />
      </motion.div>
      <div className="absolute inset-0 bg-black/60" />

      <div className="absolute inset-x-0 bottom-0 z-10">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-6 pb-12">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-mono text-xs uppercase tracking-[0.35em] text-accent"
            data-testid="visual-stat-kicker"
          >
            {stat.kicker}
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-6xl uppercase tracking-tight text-white sm:text-7xl"
            data-testid="visual-stat-value"
          >
            {stat.value}
          </motion.p>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.25 }}
            className="max-w-md text-sm leading-relaxed text-white/70"
            data-testid="visual-stat-label"
          >
            {stat.label}
          </motion.p>
        </div>
      </div>
    </section>
  );
};
